class EmbellishmentProducts {
  constructor () {
    if (!this.embellishmentBoxVariantId) return

    this.setupListeners()
  }

  setupListeners () {
    this.onCartSettled = this.onCartSettled.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.SETTLED,
      this.onCartSettled,
    )
  }

  async onCartSettled (event) {
    this.cart = event.detail.state

    if (this.hasEmbellishedProduct && !this.embellishmentBoxLineItem) {
      await this.addEmbellishmentBox()
    } else if (!this.hasEmbellishedProduct && this.embellishmentBoxLineItem) {
      await this.removeEmbellishmentBox()
    }
  }

  async addEmbellishmentBox () {
    const state = await window.BAO.Cart.addItem(
      {
        id: this.embellishmentBoxVariantId,
        quantity: 1,
        properties: {
          _embellishment_box: 'true',
        },
      },
      { sections: this.mappedSections },
    )

    if (state && 'sections' in state) this.renderSections(state.sections)
  }

  async removeEmbellishmentBox () {
    const state = await window.BAO.Cart.removeItem(
      this.embellishmentBoxLineItem.key,
      { sections: this.mappedSections },
    )

    if (state && 'sections' in state) this.renderSections(state.sections)
  }

  renderSections (stateSections) {
    const sectionsToRender = this.sections
      .filter((s) => s.section in stateSections)
      .map((s) => Object.assign({}, s, { html: stateSections[s.section] }))

    window.BAO.sectionRenderer.renderMultiple(sectionsToRender)
  }

  get mappedSections () {
    return this.sections.map((s) => s.section)
  }

  get sections () {
    return this.isCartPage
      ? window.BAO.sectionRenderer.cartSections
      : window.BAO.sectionRenderer.pushCartSections
  }

  get hasEmbellishedProduct () {
    return this.cart.items.some(
      (lineItem) => !!lineItem.properties?._embellished_product,
    )
  }

  get embellishmentBoxLineItem () {
    return this.cart.items.find(
      (lineItem) => lineItem.variant_id === this.embellishmentBoxVariantId,
    )
  }

  get embellishmentBoxVariantId () {
    const id = this.embellishmentBoxEl?.dataset?.embellishmentBox

    return id ? parseInt(id, 10) : null
  }

  get embellishmentBoxEl () {
    return this.isCartPage
      ? document.getElementById('template-cart')
      : document.querySelector('push-cart')
  }

  get isCartPage () {
    return !!document.getElementById('template-cart')
  }
}

window.BAO.EmbellishmentProducts = new EmbellishmentProducts()
